import React, { Children, useState } from "react";
import { Modal } from "react-bootstrap";
import Stepper from "./Stepper";

type Props = {
  id?: string;
  steps: string[];
  show?: boolean;
  titleText?: string;
  onClose?: $TSFixMeFunction;
  disableBackStepAt?: {
    stepIndex?: number;
    disabled?: number[];
  }[];
};

function StepperModal({
  id,
  steps,
  show,
  titleText,
  onClose,
  disableBackStepAt,
  children,
}: React.PropsWithChildren<Props>) {
  const [stepperState, setStepperState] = useState(0);

  const handleNext = async () => {
    if (stepperState !== steps.length - 1)
      setStepperState((prevStepperState) => prevStepperState + 1);
  };

  const handleBack = () => {
    if (stepperState !== 0)
      setStepperState((prevStepperState) => prevStepperState - 1);
  };

  const modalHeader = (
    <Modal.Header data-testid="modal-header">
      {titleText && <h2>{titleText}</h2>}
      <Stepper
        steps={steps}
        stepperState={stepperState}
        disableBackStepAt={disableBackStepAt}
        handleStepClicked={(index) => setStepperState(index)}
      />
    </Modal.Header>
  );

  return (
    <Modal
      data-testid={id}
      id={id}
      show={show}
      // @ts-expect-error TS(2769) FIXME: No overload matches this call.
      onHide={onClose}
      restoreFocus={false}
      dialogClassName="stepper-popup-container"
    >
      {modalHeader}
      {Children.map(
        // @ts-expect-error TS(2533) FIXME: Object is possibly 'null' or 'undefined'.
        children.filter((child) => !!child),
        (child, i) => {
          if (i === stepperState)
            return React.cloneElement(child, { handleNext, handleBack });
          return undefined;
        },
      )}
    </Modal>
  );
}

export default StepperModal;
